import { CRIME_ANALYSIS_PATH } from 'constants/paths'
import CrimeAnalysisPage from './components/CrimeAnalysisPage'

// Sync route definition
export default {
  path: CRIME_ANALYSIS_PATH,
  component: CrimeAnalysisPage
}
